import React from 'react';
import { styled } from 'linaria/react';
import { Product } from 'pages/common/components/Product';
import { FormRouter } from './form-router';

export const Content = () => (
  <Container>
    <Product />
    <FormRouter />
  </Container>
);

const Container = styled.div`
  width: 100%;
  padding: 0 104px var(--space-200) 104px;

  @media (--only-desktop) {
    padding: 0 var(--space-525) var(--space-200) var(--space-525);
  }

  @media (--only-tablet) {
    padding: 0 var(--space-675) var(--space-200) var(--space-675);
  }

  @media (--only-mobile) {
    padding: 0 var(--space-200) var(--space-200) var(--space-200);
  }
`;
